import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const Home = () => {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/login');
  };
  const location = useLocation();

  const [menu, setMenu] = useState([]);
  const [informasiAkun, setInformasiAkun] = useState({}); // Default sebagai objek kosong

  useEffect(() => {
    const fetchMenu = async () => {
      window.initScripts?.();
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        console.error("Token required");
        return;
      }

      try {
        const decoded = jwtDecode(authToken);
        setInformasiAkun(decoded || {}); // Pastikan state selalu memiliki nilai

        if (!decoded.akses) {
          navigate('/daftar/identifikasiakses');
        }
      } catch (error) {
        navigate('/login');
        return;
      }
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/menu`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
          },
        });
        if (!response.ok) {
          throw new Error("Failed to fetch menu");
        }
        const data = await response.json();
        setMenu(data);
      } catch (error) {
        console.error("Error fetching menu:", error);
      }
    };

    fetchMenu();
  }, [navigate]);

  return (
    <div>
      <nav className="pc-sidebar">
        <div className="navbar-wrapper">
          <div className="m-header">
            <a href="/admin" className="b-brand text-primary">
              <img src="/assets/images/logogvfix.png" width={100} alt="" className="logo logo-lg" />
            </a>
          </div>
          <div className="navbar-content">
            <ul className="pc-navbar">
              <li className="pc-item pc-caption">
                <label>Dashboard</label>
                <i className="ti ti-dashboard"></i>
              </li>
              {menu.map((item, index) => (
                <li
                  className={`pc-item ${Array.isArray(item.submenu) ? "pc-hasmenu" : ""} ${location.pathname === item.path ? "active" : ""}`}
                  key={index}
                >
                  <a href={item.path} className="pc-link">
                    <span className="pc-micon">
                      <i className={item.icon}></i>
                    </span>
                    {Array.isArray(item.submenu) && (
                      <span className="pc-arrow">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right" >
                          <polyline points="9 18 15 12 9 6"></polyline>
                        </svg>
                      </span>
                    )}
                    {item.label}
                  </a>

                  {Array.isArray(item.submenu) && (
                    <ul 
                      className="pc-submenu" 
                      style={{
                        display: item.submenu?.some(sub => sub.path === location.pathname) ? "block" : "none",
                        boxSizing: "border-box"
                      }}
                    >
                      {item.submenu.map((items, subIndex) => (
                        <li className={`pc-item ${location.pathname === items.path ? "active" : ""}`} key={subIndex}>
                          <a className="pc-link" href={items.path} data-i18n="Price 1">
                            {items.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
            <div className="w-100 text-center">
              <div className="badge theme-version badge rounded-pill bg-light text-dark f-12"></div>
            </div>
          </div>
        </div>
      </nav>
      <header className="pc-header">
        <div className="header-wrapper">
          <div className="me-auto">
            <ul className="list-unstyled">
              <li className="pc-h-item header-mobile-collapse">
                <a href="#" className="pc-head-link head-link-secondary ms-0" id="sidebar-hide" >
                  <i className="ti ti-menu-2"></i>
                </a>
              </li>
              <li className="pc-h-item pc-sidebar-popup">
      <a href="#" className="pc-head-link head-link-secondary ms-0" id="mobile-collapse">
        <i className="ti ti-menu-2"></i>
      </a>
    </li>
              <li className="pc-h-item ">
                <b>{informasiAkun?.sekolah || "Tidak Terdaftar"}</b>
              </li>
            
            </ul>
          </div>
          <div className="ms-auto">
            <ul className="list-unstyled">
              <li className="dropdown pc-h-item header-user-profile">
                <a className="pc-head-link head-link-primary dropdown-toggle arrow-none me-0" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false" >
                  <i className='ti ti-user user-avtar'></i>
                  <span>
                    <i className="ti ti-settings"></i>
                  </span>
                </a>
                <div className="dropdown-menu dropdown-user-profile dropdown-menu-end pc-h-dropdown">
                  <div className="dropdown-header">
                    <h4>{informasiAkun?.nama || "Guest"}</h4>
                    <p className="text-muted">{informasiAkun?.akses || "No Access"}</p>
                    <hr />
                    <div className="profile-notification-scroll position-relative" style={{ maxHeight: 'calc(100vh - 280px)' }}>
                    <a href="/admin/profile" className="dropdown-item">
                        <i className="ti ti-user-check"></i>
                        <span>Profile</span>
                      </a>
                      <a href="/lupapassword" className="dropdown-item">
                        <i className="ti ti-separator"></i>
                        <span>Ganti Password</span>
                      </a>
                      <a href="#" onClick={handleLogout} className="dropdown-item">
                        <i className="ti ti-logout"></i>
                        <span>Logout</span>
                      </a>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </header>
      <div>
        <Outlet />
      </div>
    </div>
  );
};

export default Home;